import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { ScheduleQueueResultReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: "root",
})
export class ScheduleQueueResultReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/ScheduleQueueResultReferences";

    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getScheduleQueueResultReferences(): Observable<ScheduleQueueResultReferenceModel[]> {
        return this.httpGet<ScheduleQueueResultReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}